import type { ApiParamsDefinition } from '@/api/types/api-definition';
import type { httpRequestConfig } from '@/api/types/request';

import { httpRequest } from '../request';

type RegisterRequest = ApiParamsDefinition['POST:/api/auth/register']['data'];
type LoginRequest = ApiParamsDefinition['POST:/api/auth/login']['data'];
type EmailCodeSendRequest = ApiParamsDefinition['POST:/api/auth/email_code/send']['data'];
type EmailCodeLoginRequest = ApiParamsDefinition['POST:/api/auth/email_code/login']['data'];
type CheckEmailRegisterRequest = ApiParamsDefinition['POST:/api/auth/check_email_register']['data'];
type FastRegisterRequest = ApiParamsDefinition['POST:/api/auth/fast_register']['data'];
type SendEmailRequest = ApiParamsDefinition['POST:/api/auth/reset_password_send_email']['data'];
type ResetPasswordRequest = ApiParamsDefinition['POST:/api/auth/reset_password']['data'];
type ThirdRedirectRequest = ApiParamsDefinition['GET:/api/auth/third_login_redirect']['params'];
type RecaptchaRequest = ApiParamsDefinition['GET:/tools/recaptcha/verify']['params'];

const getLoginUtmInfo = () => {
  if (typeof window === 'undefined') return {};
  const latestChannelAttribute = window.latestChannelAttribute;
  const isNotExpired = Number(latestChannelAttribute?.expires) > Date.now();
  return {
    pub_zl_utm_source: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_source || undefined
      : undefined,
    pub_zl_utm_medium: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_medium || undefined
      : undefined,
    pub_zl_utm_campaign: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_campaign || undefined
      : undefined,
    pub_zl_referrer: isNotExpired
      ? latestChannelAttribute?.pub_zl_referrer || undefined
      : undefined,
  };
};

const getTongDunBlackBox = () => {
  if (typeof localStorage === 'undefined') return undefined;
  return localStorage.getItem('vo_tong_dun_black_box') || undefined;
};

export default {
  register: (
    data: RegisterRequest,
    msgConfig: httpRequestConfig = { successMsg: true, errorMsg: false },
  ) =>
    httpRequest(
      'POST:/api/auth/register',
      {
        data: {
          ...data,
          utm_info: getLoginUtmInfo(),
          black_box: getTongDunBlackBox(),
        },
      },
      { ...msgConfig, isEncrypt: true },
    ),
  login: (data: LoginRequest, duration?: number) =>
    httpRequest(
      'POST:/api/auth/login',
      {
        data: {
          ...data,
          black_box: getTongDunBlackBox(),
        },
      },
      { successMsg: true, duration, isEncrypt: true },
    ),
  sendEmailCode: (data: EmailCodeSendRequest) =>
    httpRequest('POST:/api/auth/email_code/send', { data }, { successMsg: false }),
  emailCodeLogin: (data: EmailCodeLoginRequest) =>
    httpRequest('POST:/api/auth/email_code/login', { data }, { successMsg: false }),
  checkEmailRegister: (data: CheckEmailRegisterRequest) =>
    httpRequest('POST:/api/auth/check_email_register', { data }, { successMsg: false }),
  logout: () => httpRequest('POST:/api/customer/logout'),
  fastRegister: (
    data: FastRegisterRequest,
    msgConfig: httpRequestConfig = { successMsg: true, errorMsg: false },
  ) =>
    httpRequest(
      'POST:/api/auth/fast_register',
      {
        data: {
          ...data,
          utm_info: getLoginUtmInfo(),
          black_box: getTongDunBlackBox(),
        },
      },
      { ...msgConfig, isEncrypt: true },
    ),
  sendEmail: (data: SendEmailRequest) =>
    httpRequest('POST:/api/auth/reset_password_send_email', { data }),
  resetPassword: (data: ResetPasswordRequest) =>
    httpRequest('POST:/api/auth/reset_password', { data }, { successMsg: true }),
  /* 接口会携带token过来，通过token获取用户信息 */
  thirdRedirect: (data: ThirdRedirectRequest) =>
    httpRequest('GET:/api/auth/third_login_redirect', {
      params: {
        ...data,
        black_box: getTongDunBlackBox(),
      } as ThirdRedirectRequest,
    }),
  reCAPTCHA: (data: RecaptchaRequest) =>
    httpRequest('GET:/tools/recaptcha/verify', { params: data }),
};
